interface IndexItem {
  icon: string;
  title: string;
  count: string;
  description: string;
}

const indexItems: IndexItem[] = [
  {
    icon: 'ri-run-line',
    title: '户外真人秀',
    count: '36档节目',
    description: '奔跑、挑战、冒险，最热户外竞技真人秀',
  },
  {
    icon: 'ri-emotion-laugh-line',
    title: '搞笑脱口秀',
    count: '28档节目',
    description: '幽默段子、犀利吐槽，笑到停不下来',
  },
  {
    icon: 'ri-music-line',
    title: '音乐综艺',
    count: '24档节目',
    description: '经典舞台、天籁之音，音乐综艺全收录',
  },
  {
    icon: 'ri-restaurant-line',
    title: '美食旅行',
    count: '20档节目',
    description: '走遍各地，品味人间烟火与异国风味',
  },
  {
    icon: 'ri-heart-line',
    title: '恋爱观察',
    count: '18档节目',
    description: '甜蜜互动、心动信号，最甜恋爱综艺',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '悬疑推理',
    count: '15档节目',
    description: '密室逃脱、剧本杀，烧脑推理一触即发',
  },
  {
    icon: 'ri-home-heart-line',
    title: '慢生活综艺',
    count: '14档节目',
    description: '田园牧歌、治愈日常，慢下来的美好',
  },
  {
    icon: 'ri-star-line',
    title: '偶像竞演',
    count: '22档节目',
    description: '选秀舞台、偶像诞生，见证梦想起航',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            专题合集
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            综艺节目分类索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            八大综艺分类，助你快速找到想看的内容类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group bg-background-100 rounded-xl p-5 border border-background-200/70 transition-all duration-300 hover:border-primary-200 hover:bg-background-50"
            >
              <div className="w-11 h-11 rounded-lg bg-primary-100 flex items-center justify-center mb-3 transition-colors group-hover:bg-primary-200">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-1.5">
                <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}